import actions from './actions';

const initState = {
    accounts: [],
    activeAccount: {},
    loading: false,
};

export default function reducer(state = initState, action) {
    switch (action.type) {
        case actions.ADD_ACCOUNT_SUCCESS:
            return {
                ...state,
                accounts: [...state.accounts, action.account],
            };
        case actions.FETCH_ACCOUNTS:
            return {
                ...state,
                loading: true,
            };
        case actions.FETCH_ACCOUNTS_SUCCESS:
            const accountsSorted = action.accounts && Array.isArray(action.accounts.clients)
                ? action.accounts.clients.sort((a, b) => a.name.localeCompare(b.name))
                : [];
            let accountFinalSort;
            if (accountsSorted.length > 0) {
                const dignioAccount = accountsSorted.find(account => {
                    const accountName = account.name.toLowerCase().trim();
                    return accountName === "dignio" || 
                           accountName === "dignio account" ||
                           accountName.startsWith("dignio");
                });
                const otherAccounts = accountsSorted.filter(account => {
                    const accountName = account.name.toLowerCase().trim();
                    return accountName !== "dignio" && 
                           accountName !== "dignio account" &&
                           !accountName.startsWith("dignio");
                });
                accountFinalSort = dignioAccount ? [dignioAccount, ...otherAccounts] : accountsSorted
            }
            return {
                ...state,
                accounts: accountFinalSort,
                activeAccount: {},
            };
        case actions.SELECT_ACCOUNT:
            return {
                ...state,
                loading: true,
            };
        case actions.SELECT_ACCOUNT_SUCCESS:
            return {
                ...state,
                activeAccount: action.account,
                loading: false,
            };
        case actions.SWITCH_ACCOUNT:
            return {
                ...state,
                activeAccount: state.accounts.find(account => account.clientId === action.accountId),
            };
        default:
            return state;
    }

}
